import { userProfileConstants } from '../../_constants';



const initialState = { setPasswordLoading: true, data: '', error: false };

export function setPasswordReducer(state = initialState, action) {

    switch (action.type) {
        case userProfileConstants.REQUEST_SET_PASSWORD:
            return {
                setPasswordLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_SET_PASSWORD:

            return {
                setPasswordLoading: false,
                data: action.changePassword,
                error: false
            };
        case userProfileConstants.SET_PASSWORD_ERROR:

            return {
                setPasswordLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/setPassword.reducer.js